import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
//import OutlinedInput from '@mui/material/OutlinedInput';
import { Document, Page, pdfjs } from 'react-pdf'
// import { pdf, Document, Page, Text, View, Image } from '@react-pdf/renderer';
import termsPDF from '../../../_assets/pdf/terms_and_conditions.pdf';

// interface UserAgreementProps {
//     open: boolean;
//     handleAgreementPageClose: () => void;
//     setAgreementSigned: (boolean) => void;
// }

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export { UserAgreement };

function UserAgreement({ open, handleAgreementPageClose, setAgreementSigned }: UserAgreementProps) {

    const [numPages, setNumPages] = useState(null);
    // function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    //     setNumPages(numPages);
    // }
    // }

    const styles = {
        Document: {
            width: "100%",
            // width: "1000px",
            // margin: "auto",
            marginTop: '30px',
            marginBottom: '10px',
            marginLeft: '0px',
            marginRight: '0px',
            // margin: "0px",
            padding: "0px"
        },
        page: {
            // width: "700px",
            width: "100%",
            // width: "1000px",
            margin: "0px",
            padding: "0px"
        }
    };

    return (
        // <Stack direction={"column"}
        //  sx={{width: '100px'}}
        // >
        <Dialog
            open={open}
            onClose={handleAgreementPageClose}
            PaperProps={{
                component: 'form',
                onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    handleAgreementPageClose();
                },
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        // width: "2000px !important",
                        height: '1000px',
                        // maxWidth: "1000px",  // Set your width here
                    },
                },
            }}
        >
            {/*<DialogTitle> KeyInsight Data User Agreement</DialogTitle>*/}

            <DialogContent
                // scroll={"paper"}
                // sx={{ width: '600px', display: 'flex', gap: 0, padding: 0, mx: 0, border: 1 }}
                // dividers={true}
                style={styles.Document}
            >
                {/*<DialogContentText>*/}
                    {/*<div style={{ width: "100%", height: "100%" }}>*/}
                        <Document
                            file={termsPDF}
                            // onLoadSuccess={onDocumentLoadSuccess}
                            onLoadSuccess={({ numPages })=>setNumPages(numPages)}
                            // className="my-react-pdf"
                            // onLoadError={onLoadError}
                            // className={styles.Document}
                            loading={""}
                            // className={styles.Document}
                            // sx={{width: '900px', height: '100%'}}
                        >
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page
                                    wrap={false}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                    customTextRenderer={false}
                                    key={`page_${index + 1}`}
                                    // className="my-react-pdf"
                                    pageNumber={index + 1}
                                    // style={styles.page}
                                    scale={0.95}
                                    loading={""}
                                >
                                    {/*<View style={{ lineHeight: "0" }}>*/}
                                    {/*    <Text style={{ width: 1000 }}>  /!* <==== *!/*/}
                                    {/*    </Text>*/}
                                    {/*</View>*/}
                                </Page>
                            ))}
                        </Document>
                    {/*</div>*/}
                {/*</DialogContentText>*/}
            </DialogContent>
            <DialogActions sx={{ pb: 3, px: 3, gap: 2 }}>
                <Button onClick={handleAgreementPageClose} sx={{ width: '20%' }}>Cancel</Button>
                <Button variant="contained" sx={{ width: '20%' }} onClick={() => { handleAgreementPageClose(); setAgreementSigned(true) }}
                >
                    Agree
                </Button>
            </DialogActions>
        </Dialog>
        // </Stack>
    );
}
